import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import EmpresaForm from '../components/EmpresaForm';
import { maskCPF, maskCNPJ, limparCpfCnpj } from '../utils/Masker';
import moment from "moment-timezone"; // VALIDAR DATAS
import { resolveImageUrl } from "../utils/Storage";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 20,
    total: 0,
  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/empresas', {
        params: {
          page: pagina,
          limite: limite,
          nome: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.emp_codigo) {
      request = axios.put(`/empresas/update/${registro.emp_codigo}`, registro);
    } else {
      request = axios.post(`/empresas/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Empresa gravada com sucesso.');
      })
      .catch(error => {
        let mensagem = '';
        if (error.response.data.emp_cpf_cnpj) {
          mensagem = error.response.data.emp_cpf_cnpj;
        }
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + mensagem, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/empresas/show/${registro.emp_codigo}`)
      .then(response => {
        const { data } = response;

        data.emp_municipio = {
          key: String(data.emp_municipio),
          label: data.cmun_descricao,
          cmun_uf: String(data.cmun_uf),
          cuf_sigla: data.cuf_sigla,
        }

        const cpfCnpjLimpo = limparCpfCnpj(data.emp_cpf_cnpj);
        data.emp_cpf_cnpj = /^[0-9]{11}$/.test(cpfCnpjLimpo)
          ? maskCPF(cpfCnpjLimpo)
          : maskCNPJ(cpfCnpjLimpo);

        data.emp_data_contrato = moment(data.emp_data_contrato, 'YYYY-MM-DD').format('DD/MM/YYYY');
        // data.emp_vlr_mensal = maskDecimal(data.emp_vlr_mensal);

        data.base64 = '';
        data.pathImagem = data.emp_logo ? resolveImageUrl(`emp${data.emp_codigo}/${data.emp_logo}`) : '';
        // data.pathImagem = data.emp_logo ? resolveImageUrl(`emp${data.emp_codigo}/logo.${data.emp_logo}`) : '';

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/empresas/delete/${registro.emp_codigo}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.emp_codigo === registro.emp_codigo)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        emp_codigo: '',
        emp_nome: '',
        emp_razao_social: '',
        emp_situacao: '',
        emp_cpf_cnpj: '',
        emp_cep: '',
        emp_endereco: '',
        emp_numero: '',
        emp_complemento: '',
        emp_bairro: '',
        emp_municipio: { key: '0' },
        emp_filial: '',
        emp_filial1: '',
        emp_licencas: '0',
        emp_data_contrato: moment().format('DD/MM/YYYY'),
        emp_vlr_mensal: 0,
        emp_obs: '',
        par_local_servidor: 'UNICO',
        par_codigo_liberar_senha: '',
        par_entrega_itens_vendas: 0,
        par_flag_impr_ped_sem_descon: 0,
        par_exportar_orcamentos: 0,

        imgNome: '',
        imgSize: '0',
        imgData: '',
        base64: '',
        pathImagem: null,
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/empresas/ativa/${registro.emp_codigo}/1`)
    } else {
      request = axios.put(`/empresas/ativa/${registro.emp_codigo}/0`)
    }

    request.then(response => {
      registro.emp_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };



  renderPFJ = (emp_cpf_cnpj) => {
    const value = limparCpfCnpj(emp_cpf_cnpj);
    return (
      <span>
        {/^[0-9]{11}$/.test(value) ? maskCPF(value) : maskCNPJ(value)}
      </span>
    );
  };

  renderAtiva = (emp_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={emp_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        style={{ backgroundColor: !emp_situacao ? null : Colors.primary }}
      />
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    // console.log('EmpresasPage: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Cadastro de Empresas</h2>
        <hr />
        <br />

        <div className="pageFiltro">
          <Button
            onClick={this.onAdicionarClick}
            className="pageFiltro-adicionar"
          >
            Adicionar
          </Button>

          <Search
            placeholder="Buscar por Nome"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <EmpresaForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          // scroll={{ x: 600 }}
          rowKey={(registro => registro.emp_codigo)}
        >
          <Column
            key="emp_codigo"
            dataIndex="emp_codigo"
            title="Código"
            width={"5%"}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="emp_nome"
            dataIndex="emp_nome"
            title="Nome"
            width={"25%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cmun_descricao"
            dataIndex="cmun_descricao"
            title="Cidade"
            width={"15%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="cuf_sigla"
            dataIndex="cuf_sigla"
            title="UF"
            width={"5%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="emp_cpf_cnpj"
            dataIndex="emp_cpf_cnpj"
            title="CPF/CNPJ"
            render={this.renderPFJ}
            width={"10%"}
            align="right"
            className="listaCadastro"
          />
          <Column
            key="par_ult_importacao"
            dataIndex="par_ult_importacao"
            title="Importação"
            render={this.renderData}
            width={"10%"}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="emp_situacao"
            dataIndex="emp_situacao"
            title="Situação"
            render={this.renderAtiva}
            width={"5%"}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title="Ações"
            render={this.renderAcoes}
            width={"10%"}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EmpresasPage.js